import { z } from 'zod'

import { dataDisplayTypes, segmentDisplayTypes } from '~/utils'

import {
  type RestoringParams,
  type RestoringParamsAddition,
  type RestoringParamsOrigin,
} from '../types'

const schema2Origin = z.object({
  version: z.literal(2),
  revision: z.number(),
  brandGroupId: z.number(),
  columnCustomerAttributeIds: z.array(z.string()),
  brandIds: z.array(z.number()),
  questionIds: z.array(z.string()),
  customerAttributeIds: z.array(z.string()),
  dataDisplayType: z.enum(dataDisplayTypes),
  segmentDisplayType: z.enum(segmentDisplayTypes),
  sortValue: z
    .object({
      columnKey: z.string(),
      ascending: z.boolean(),
    })
    .nullable(),
  hiddenRowIds: z.array(z.string()),
}) satisfies z.ZodSchema<RestoringParamsOrigin>

const schema2Addition = z.object({
  columnCustomerAttributesDiffs: z.array(z.tuple([z.string(), z.string()])),
  comment: z.string(),
}) satisfies z.ZodSchema<RestoringParamsAddition>

export const schema2 = schema2Origin.merge(
  schema2Addition.partial(),
) satisfies z.ZodSchema<RestoringParams>
